import { render, staticRenderFns } from "./HaloScenario.vue?vue&type=template&id=5b3455be&scoped=true&"
import script from "./HaloScenario.vue?vue&type=script&lang=js&"
export * from "./HaloScenario.vue?vue&type=script&lang=js&"
import style0 from "./HaloScenario.vue?vue&type=style&index=0&id=5b3455be&prod&lang=css&"
import style1 from "./HaloScenario.vue?vue&type=style&index=1&id=5b3455be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3455be",
  null
  
)

export default component.exports